import { Button } from "components/common/buttons/Button";
import { NoProjectsProps } from "./NoProjects.types";

export const NoProjects = ({ className, onCreate, canCreateProject = true }: NoProjectsProps) => (
  <div className={`text-center py-8 ${className}`}>
    <div className="text-muted-foreground text-sm mb-2">No Projects</div>
    <div className="text-muted-foreground/70 text-xs mb-4">
      {canCreateProject
        ? "Create your first project to get started"
        : "Ask a workspace admin to create a project or grant you access"}
    </div>
    {canCreateProject ? (
      <Button variant="ghostBrand" size="sm" onClick={onCreate} className="w-full">
        Create Project
      </Button>
    ) : null}
  </div>
);
